import React from "react";
import { Link } from "react-router-dom";

export default function DestinosPrimariosSeleccion({ hasTitle, bgColor }) {
  return (
    <>
      <section id="team" className={`team-member-section ptb-100 ${bgColor}`}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-8">
              <div className="section-heading text-center mb-5">
                {hasTitle ? (
                  <span className="text-uppercase color-secondary sub-title">
                    Elegí tu destino
                  </span>
                ) : (
                  ""
                )}
                <h2>Viaje de Egresados para Primarios</h2>
                <p className="lead">
                  ¡Atención padres y maestros!
                  ¿Están listos para planificar un viaje de egresados inolvidable para sus alumnos de primaria? Aquí les presento tres emocionantes destinos que harán que esta experiencia sea única y memorable
                </p>
              </div>
            </div>
          </div>
          <div className="row justify-content-center" style={{ display: "flex", }}>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minivillacarlozpaz.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Villa Carlos Paz</h5>
                  <h6>Sierras</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                  <Link
                      to="/villa-carlos-paz"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span
                        className="ti-arrow-right"
                      ></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minisanpedro.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">San Pedro</h5>
                  <h6>Playa-Campo</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/san-pedro"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span
                        className="ti-arrow-right"
                      ></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/miniramallo.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Ramallo</h5>
                  <h6>Playa-Campo</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/ramallo"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span
                        className="ti-arrow-right"
                      ></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-sm-6">
              <div className="single-team-member position-relative">
                <div className="team-image">
                  <img
                    src="assets/img/miniportadas/minicostaatlantica.jpg"
                    alt="Team Members"
                    className="img-fluid rounded-circle"
                  />
                </div>
                <div className="team-info text-white rounded-circle d-flex flex-column align-items-center justify-content-center">
                  <h5 className="mb-0">Costa Atlántica</h5>
                  <h6>Mar</h6>
                  <ul className="list-inline team-social social-icon mt-4 text-white">
                    <Link
                      to="/costa-atlantica-primarios"
                      className="popup-youtube video-play-icon d-inline-block"
                    >
                      <span
                        className="ti-arrow-right"
                      ></span>{" "}
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
